import React from 'react';
import { Image } from 'react-konva';
import ROI from 'components/main/images/ROI.png';

export default function RegionOfInterest(props) {
  const drawImage = () => {
    const imageObj = new window.Image();
    imageObj.src = ROI;
    const loc = props.loc;
    return (
      <Image
        id='regionofinterest-img'
        x={loc.x + props.index * props.iconwidth}
        y={loc.y + loc.h - props.iconheight}
        image={imageObj}
        width={props.iconwidth}
        height={props.iconheight}
      />
    );
  };

  return drawImage();
}
